import { MAX_PERIOD_DAYS } from '../GscTools/period';
import { emptyDraft, resolveScope } from '../GscTools/scope';
import { SCOPE_KEYS, hasScope, scopeDraftFromParams, scopeParamsFromScope } from '../GscTools/url';
import { DEFAULT_SOURCE, isSource } from './sources';

/**
 * The scope this report runs under: the shared one, narrowed to the three news surfaces.
 *
 * The source *is* the search type — Search Console's `type` — so it rides on the shared
 * `searchType` field rather than on a field of its own, and every shared helper that reads the
 * surface (which metrics it reports, whether it has a position, how it is labelled) reads it
 * correctly here without being told. What this report adds is the restriction: only Discover,
 * Google News and the News tab, and Discover when anything else is asked for.
 *
 * Device is not offered and not sent. The report's controls are the property, the window, the
 * comparison, the source and the country its own breakdown sets, and a device filter arriving from
 * another tool's link would otherwise narrow every figure here without the bar ever showing it.
 */
export function initialDraft(period) {
    return {
        ...emptyDraft(period),
        searchType: DEFAULT_SOURCE,
    };
}

export function resolveReportScope(draft, t) {
    const scope = resolveScope(
        { ...draft, searchType: isSource(draft.searchType) ? draft.searchType : DEFAULT_SOURCE },
        t,
        { maxDays: MAX_PERIOD_DAYS },
    );

    return { ...scope, device: '' };
}

/** The shared query-string keys, which already carry the source as `type`. */
export const URL_KEYS = SCOPE_KEYS;

export function hasReportScope(params) {
    return hasScope(params);
}

/**
 * The draft this report starts from when its address already describes one.
 *
 * A `type` that is not one of the three sources is dropped rather than kept: a link from Search
 * Overview naming Web Search would otherwise open this page reading a surface it does not offer.
 */
export function reportDraftFromParams(params) {
    const draft = scopeDraftFromParams(params);

    if (!isSource(draft.searchType)) delete draft.searchType;
    delete draft.device;

    return draft;
}

export function reportParamsFromScope(scope) {
    return scopeParamsFromScope(scope);
}
